/**
 * Hook for role label utilities with org context.
 * Use for programmatic label lookup and string replacement.
 */

import { useCallback, useMemo } from "react";
import { useAppContext } from "../context/AppContext";
import type { RoleLabelsByKey } from "../object-actions/types/types";
import { applyRoleLabels, getRoleDisplayLabel } from "../utils/roleLabels";

export function useRoleLabels() {
  const { organization } = useAppContext();
  const labels = organization?.role_labels ?? null;

  const apply = useCallback(
    (text: string) => applyRoleLabels(text, labels),
    [labels]
  );

  const getLabel = useCallback(
    (roleKey: keyof RoleLabelsByKey, options?: { plural?: boolean }) =>
      getRoleDisplayLabel(labels, roleKey, options),
    [labels]
  );

  return useMemo(
    () => ({
      labels,
      applyRoleLabels: apply,
      getRoleLabel: getLabel,
    }),
    [labels, apply, getLabel]
  );
}
